import queryString from "query-string";
import { useQuery } from "react-query";
import {
    GetPenyewaSaatIniResponse,
} from "../../constants/types";
import axios from "../axios";

const handleRequest = async (
    id: number,
) => {
    const apiUrl = queryString.stringifyUrl({
        url: `/api/mruangans/${id}/extends`,
    });
    const { data } = await axios.get<GetPenyewaSaatIniResponse>(apiUrl);
    return data.data;
};

export default function useDetailHistoryRoomExtends(id: number, enabled: boolean) {
    return useQuery<GetPenyewaSaatIniResponse["data"]>(
        ["detailRoomExtends", id],
        () => handleRequest(id),
        { enabled: !!id && enabled }
    );
}


